export default "__VITE_PUBLIC_ASSET__07ebc15a__"